import { cn } from '@/lib/shared/ui';
import React from 'react';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const ContentWrapper = (props: Props) => {
  return <div {...props} className={cn('max-w-6xl mx-auto w-[84%]', props.className)} />;
};
